document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function (_defaultFilter) {
    let user_location = document.cookie.match(RegExp('(?:^|;\\s*)' + 'user_location' + '=([^;]*)'));
    if (user_location[1] != '00') {
      let uploaction = parseInt(user_location[1]);
      if(uploaction > 100){
        if(_defaultFilter){
          return _defaultFilter + ' AND meta.custom.inventory_locations.'+user_location[1]+'> 0';
        }else{
          return 'meta.custom.inventory_locations.'+user_location[1]+' > 0';
        }
        //return _defaultFilter + 'AND locations_inventory.' + user_location[1] + ' > 0';
      }else{
        if(_defaultFilter){
          return _defaultFilter + ' AND meta.custom.available_at_' + user_location[1] + ':true';
        }else{
          return 'meta.custom.available_at_' + user_location[1] + ':true';
        }
      }

   
    }
  });
});

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeAutocompleteFiltersString', function (_defaultFilter) {
    let user_location = document.cookie.match(RegExp('(?:^|;\\s*)' + 'user_location' + '=([^;]*)'));
    if (user_location[1] != '00') {
      let uploaction = parseInt(user_location[1]);
      if(uploaction > 100){
  if(_defaultFilter){
        return _defaultFilter + ' AND meta.custom.inventory_locations.'+user_location[1]+' > 0'
        }else{
          return 'meta.custom.inventory_locations.'+user_location[1]+' > 0';
        }
     //   return _defaultFilter + 'AND meta.custom.inventory_locations.*.105003516192 = 0';
     //   return _defaultFilter + 'AND locations_inventory.' + user_location[1] + ' > 0';
      }else{
        if(_defaultFilter){
          return _defaultFilter + ' AND meta.custom.available_at_' + user_location[1] + ':true';
        }else{
          return 'meta.custom.available_at_' + user_location[1] + ':true';
        }
     // return _defaultFilter + ' AND meta.custom.available_at_' + user_location[1] + ':"true"';
      }
    } 
  });
});

document.addEventListener('algolia.hooks.initialize', function () {


  
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components) {
  
  let user_location = document.cookie.match(RegExp('(?:^|;\\s*)' + 'user_location' + '=([^;]*)'));
  let maxproductAdd = 0;
  if (user_location[1] != '00' & parseInt(user_location[1]) > 100 ) {
      maxproductAdd = hit.meta?.custom?.inventory_locations[user_location[1]];
  }else if(user_location[1] != '00' & parseInt(user_location[1]) < 100 ){
  let allLocation = JSON.parse(shopLocations);
  let matrixLocation = allLocation.shopToStateLocationIds[stateName];

  for(let n=0; n < matrixLocation.length; n++ ){
    maxproductAdd = maxproductAdd + parseInt(hit.meta?.custom?.inventory_locations[matrixLocation[n]])
 //   console.log(maxproductAdd, matrixLocation[n],'matrixLocationmatrixLocation',hit.meta?.custom?.inventory_locations[matrixLocation[n]]);
  }
  }

    const parser = new DOMParser();
    const countHtml = parser.parseFromString(hit.meta?.judgeme?.badge, "text/html");
    const element = countHtml.querySelector('.jdgm-prev-badge');
    const forAriaelement = countHtml.querySelector('.jdgm-prev-badge__stars');
    const averageRating = element ? element.getAttribute('data-average-rating') : '5:00';
    const totalRating = element ? element.getAttribute('data-number-of-reviews') : '0';
    const arialabel = element ? forAriaelement.getAttribute('aria-label') : '0 Stars';
    const reviewText = element ? element.querySelector('.jdgm-prev-badge__text').textContent : 'No Reviews';
    const shortDescription = hit.meta?.custom?.models_custom_short_description || '';
    const truncatedText = shortDescription.length > 50 ? shortDescription.slice(0, 50) + '...' : shortDescription;


    const allJudmeStar = element ? Array.from(element.querySelectorAll('.jdgm-star')).map((item)=>{
      return item.classList[1];
    }):['jdgm--off','jdgm--off','jdgm--off','jdgm--off','jdgm--off'];
    return html`
  <div class="ais-product product-item card">
  
  <a  href="${algoliaShopify.helpers.instantsearchLink(hit)}" class="card__image product-item__image" style="padding-top:100%;min-height: 296px;">
<figure class="lazy-image product-item__image-figure product-item__image-figure--primary lazy-image--animation lazy-image--background lazy-image--fit lazyloaded" data-crop="true">

	<img src="${algoliaShopify.helpers.largeImage(hit)}" alt="${hit.title} - ${hit.variant_title}" srcset="" class="img" width="115" height="500" data-ratio="" sizes="(max-width: 474px) calc(100vw - 30px),  (max-width: 767px) calc((100vw - 50px) / 2), (max-width: 1023px) calc((100vw - 100px) / 3), (max-width: 1280px) calc((100vw - 120px) / 4), 300px" onload="this.parentNode.classList.add('lazyloaded')" />

</figure>
</a>
 <div class="card__text product-item__text gutter--regular spacing--xlarge remove-empty-space text-align--left">
      <a class="product-item__title"  href="${algoliaShopify.helpers.instantsearchLink(hit)}" title="${components.Highlight({ attribute: 'title', hit })}">
          <div class="remove-line-height-space--small">
            <span class="text-animation--underline text-size--xlarge text-line-height--small text-weight--bold text-animation--underline">  ${components.Highlight({ attribute: 'title', hit })}
               ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            
            </span>
          </div>
        </a>
        <p class="subtitle"> ${truncatedText}</p>
 
 
 <div class="product-item__price text-size--large equalize-white-space">
  <div class="remove-line-height-space">
    <div class="ais-hit--price-container">
      ${["Cellar Select", "Cellar Premium", "Cellar Ultra"].includes(
        hit.meta?.custom?.mapped_custom_wine_data_custom_collection
      )
        ? html`
             <div class="ais-hit--price-single" >
  <p>${hit.meta?.custom?.mapped_custom_wine_data_custom_bottle_size} Btl</p>
    <p class="ais-hit--price"> 
      <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
      ${!hit._distinct &&
      html`
          <span class="ais-hit--price-striked"
            ><span
              >${algoliaShopify.helpers.displayStrikedPrice(
        hit.price,
        hit.compare_at_price
      )}</span
            ></span
          >
        `}
      ${!hit._distinct &&
      html`
          <span class="ais-hit--price-discount"
            >${algoliaShopify.helpers.displayDiscount(
        hit.price,
        hit.compare_at_price,
        hit.price_ratio
      )}</span
          >
        `}
    </p>
  </div>

        <!-- 30% off for 12 bottles -->
        <div class="ais-hit--price-multiple">
        <p class="mix_p1">Mix & Match</p>
        <p class="mix_p2">Any 12 Btls</p>
          <p class="ais-hit--bulk-discount">
         <span class="redcolor"> ${`$${(hit.price * 0.65).toFixed(2)}`} </span>
          <del class="product-price--compare ">  ${`$${(hit.price).toFixed(2)}`} </del>
          </p>
        </div>
          `
        : html`
            <div class="ais-hit--price-single" >
    <p class="ais-hit--price"> 
      <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
      ${!hit._distinct &&
      html`
          <span class="ais-hit--price-striked"
            ><span
              >${algoliaShopify.helpers.displayStrikedPrice(
        hit.price,
        hit.compare_at_price
      )}</span
            ></span
          >
        `}
      ${!hit._distinct &&
      html`
          <span class="ais-hit--price-discount"
            >${algoliaShopify.helpers.displayDiscount(
        hit.price,
        hit.compare_at_price,
        hit.price_ratio
      )}</span
          >
        `}
    </p>
  </div>
          `}
    </div>
  </div>
</div>

 <div class='jdgm-widget jdgm-preview-badge ais-hit-jdgm-preview-badge'>
   	<div style='display:none' class='jdgm-prev-badge' data-average-rating='${averageRating}' data-number-of-reviews='${totalRating}' data-number-of-questions='0'> 
	  <span class='jdgm-prev-badge__stars' data-score='${averageRating}' tabindex='0' aria-label='${arialabel}' role='button'> 
	    <span class='jdgm-star ${allJudmeStar[0]}'></span>
	    <span class='jdgm-star ${allJudmeStar[1]}'></span>
	    <span class='jdgm-star ${allJudmeStar[2]}'></span>
	    <span class='jdgm-star ${allJudmeStar[3]}'></span>
	    <span class='jdgm-star ${allJudmeStar[4]}'></span> 
	    </span> 
	    <span class='jdgm-prev-badge__text' style="visibility:visible"> ${reviewText}</span> 
	    </div>
  </div> 
       
      </div>
    <div class="ais-hit--details">



    
      ${!hit._distinct &&
      html`   <quick-add-to-cart>
      <product-form  data-ajax-cart >
         <div class="quick-add-to-cart-button">    

         <form method="post" 
         id="product_form_${hit.objectID}" 
         accept-charset="UTF-8" 
         class="shopify-product-form" 
         enctype="multipart/form-data">
      <input type="hidden" name="form_type" value="product"/>
      <input type="hidden" name="utf8" value="✓" />
  
            <input type="hidden" name="id" value="${hit.objectID}" />
            <input type="hidden" name="product-id" value="${hit.id}" />
        <input type="hidden" class="max_add_product" value="${maxproductAdd}" />
        
        
            ${maxproductAdd
          ? html`
                <button class="button button--outline button--regular button--fullwidth button--loader" data-js-product-add-to-cart type="submit" name="add">
            <span class="button__text">   ${algoliaShopify.translations.addToCart}</span>
            <span class="button__preloader">
              <svg class="button__preloader-element" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke-width="4"/></svg>
            </span>
          </button>  
        
                `
          : html`
                  <button
                    class="button button--outline button--regular button--fullwidth  disabled button--loader" disabled   >
                   Sold Out
                  </button>
                `}
            </form>

          </div>
          </product-form>
  </quick-add-to-cart>
        `}
    </div>
    
    <div class="product-item_celler__badges">
 ${hit.meta?.custom?.mapped_custom_wine_data_custom_collection === 'Cellar Select' &&
      html`<img src="https://cdn.shopify.com/s/files/1/0792/4803/2032/files/Cellar_Select.png?v=1737730869" width="70" height="70" />`}
 ${hit.meta?.custom?.mapped_custom_wine_data_custom_collection === 'Cellar Premium' &&
      html`<img src="https://cdn.shopify.com/s/files/1/0792/4803/2032/files/Cellar_Premium.png?v=1737730869" width="70" height="70" />`}
 ${hit.meta?.custom?.mapped_custom_wine_data_custom_collection === 'Cellar Ultra' &&
      html`<img src="https://cdn.shopify.com/s/files/1/0792/4803/2032/files/Cellar_Ultra.png?v=1737730869" width="70" height="70" />`}
   
   
   
        </div>

    <div class="product-item__badges ">
      <!-- Add badge if the tag matches a specific condition -->
      ${hit.tags?.includes('Kosher') &&
      html`<span class="product-item__badge product-item__badge--kosher" style="background-color:#BFBB25; color:#fff" >Kosher</span>`}
      ${hit.tags?.includes('Organic') &&
      html`<span class="product-item__badge product-item__badge--kosher" style="background-color:#42210B; color:#fff" >Organic</span>`}
   
      ${hit.tags?.includes('Vegan') &&
      html`<span class="product-item__badge product-item__badge--kosher" style="background-color:#045604; color:#fff" >Vegan</span>`}
   
      ${hit.tags?.includes('ca:Home Page Best Sellers') &&
      html`<span class="product-item__badge product-item__badge--best-saller" style="background-color:#D14545; color:#fff" >Best Seller</span>`}
</div>
  </div>
`;

  });
});


